import React from "react";
import Images from "../../Component/Simage";

function Transcoding() {
  return (
    <div className="depin_smart_storage cpu_gpu">
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3 mb-lg-0">
          <div className="left_sec position-relative">
            <img src={Images.transcoding} className="img-fluid img_src" />
            
            <img src={Images.chip} className="img-fluid img_src_chip" />
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div className="ryt_sec">
            <div>
              <p className="pre-title fw-500">Transcoding & AI Computation</p>
              <p className="title fw-700">CPU & GPU</p>
              <p className="des fw-300 mb-0">
                Your Node performs optimal formatting of media files, known as
                transcoding. Nodes also power AI computation within the W3AI
                ecosystem.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Transcoding;
